<div id="modalMetadata" class="div-modal-dialog">
    <div>
        <div>
            <div>
                <div class="div-boton-cerrar-dialog"><button mat-button mat-dialog-close (click)="closeDialog()" class = "botonCerrarX">X</button>
                </div>
                <div>
                    <h1 class="metadata-titulo">Información sobre la serie</h1>
                </div>
            </div>
            <div>
                <table class="metadata-tabla">
                    <tbody>
                        <tr>
                            <th>Nombre</th>
                            <td class="td-nombre-serie">{{detalleSerie.nombre}}</td>
                        </tr>
                        <tr>
                            <th>Categoria</th>
                            <td>{{detalleSerie.categoria}}</td>
                        </tr>
                        <tr>
                            <th>Unidad</th>
                            <td>{{detalleSerie.unidad}}</td>
                        </tr>
                        <tr
                            *ngIf="detalleSerie.descripcionPeriodicidad != null && detalleSerie.descripcionPeriodicidad != ''">
                            <th>Periodicidad</th>
                            <td>{{detalleSerie.descripcionPeriodicidad}}</td>
                        </tr>
                        <tr
                            *ngIf="detalleSerie.desestacionalizacion != null && detalleSerie.desestacionalizacion != ''">
                            <th>Ajuste Estacional</th>
                            <td>{{detalleSerie.desestacionalizacion}}</td>
                        </tr>
                        <tr *ngIf="detalleSerie.baseSerie != null && detalleSerie.baseSerie != ''">
                            <th>Base</th>
                            <td>{{detalleSerie.baseSerie}}</td>
                        </tr>
                        <tr *ngIf="detalleSerie.fuente != null && detalleSerie.fuente != ''">
                            <th>Fuente</th>
                            <td>{{detalleSerie.fuente}}</td>
                        </tr>
                        <tr *ngIf="detalleSerie.precioSerie != null && detalleSerie.precioSerie != ''">
                            <th>Precio de la Serie</th>
                            <td>{{detalleSerie.precioSerie}}</td>
                        </tr>
                        <tr>
                            <th>Disponibilidad del dato</th>
                            <td>{{detalleSerie.fechaInicial}} - {{detalleSerie.fechaFinal}}</td>
                        </tr>
                        <tr>
                            <th>Fecha último Cargue</th>
                            <td>{{detalleSerie.fechaUltimoCargue}}</td>
                        </tr>
                        <tr *ngIf="detalleSerie.geografia != null && detalleSerie.geografia != ''">
                            <th>Geografía</th>
                            <td>{{detalleSerie.geografia}}</td>
                        </tr>
                        <tr *ngIf="detalleSerie.periodoReferencia != null && detalleSerie.periodoReferencia != ''">
                            <th>Periodo de Referencia</th>
                            <td>{{detalleSerie.periodoReferencia}}</td>
                        </tr>  
                        <tr>
                            <th rowspan="1">
                                <div class="div-boton-glosario"><a href="https://www.banrep.gov.co/es/glosario" target="_blank">Glosario</a></div>
                                </th>
                        </tr>                       
                        <tr *ngIf="detalleSerie.notas != null && detalleSerie.notas.length > 1">
                            <th colspan="2">
                                Descripción
                            </th>
                        </tr>
                        <tr *ngIf="detalleSerie.notas != null && detalleSerie.notas.length > 1">
                            <td colspan="2">
                                <div class="recuadro-notas" [innerHTML]="detalleSerie.notas"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <button mat-button mat-dialog-close class="botonCerrar" (click)="closeDialog()">Cerrar</button>
        </div>
    </div>

</div>